import React, { useState } from "react";

import TabsComponent from "../../../../Components/Tab";
import { ComingSoonContent } from "../WorkspacePlaceholderCard";

type TipsTab = "weekly-habits" | "suggestions";

type TipsAndRecommendationsCardProps = {
  className?: string;
};

const TIPS_TABS = [
  { id: "weekly-habits", label: "Weekly Habits" },
  { id: "suggestions", label: "Suggestions", disabled: true },
];

const TipsAndRecommendationsCard: React.FC<TipsAndRecommendationsCardProps> = ({
  className = "",
}) => {
  const [activeTab, setActiveTab] = useState<TipsTab>("weekly-habits");

  return (
    <section
      className={`box-border flex min-h-[280px] w-full min-w-0 flex-col overflow-hidden rounded-lg border border-[#EBEBEB] bg-white px-4 pb-3 pt-3.5 ${className}`}
    >
      <h2 className="m-0 shrink-0 text-base font-bold leading-6 text-black">
        Tips and Recommendations
      </h2>
      <hr className="m-0 mb-3 mt-3 w-full shrink-0 border-0 border-t border-[#F6F6F6]" />

      <div className="shrink-0 border-b border-[#F6F6F6]">
        <TabsComponent
          tabs={TIPS_TABS}
          activeTab={activeTab}
          onTabChange={(id: string) => setActiveTab(id as TipsTab)}
          variant="tab-underline"
        />
      </div>

      <div className="relative flex min-h-0 flex-1 overflow-hidden">
        {activeTab === "weekly-habits" ? <ComingSoonContent /> : null}
      </div>
    </section>
  );
};

export default TipsAndRecommendationsCard;
